import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { mutatorAction } from 'satcheljs';
import {
    getIsBitSet,
    type ListViewBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { getStore } from '../store/store';
import { shouldHideFavoritesList } from '../selectors/shouldHideFavoritesList';

const initializeShouldHideFavoritesList = mutatorAction('initializeShouldHideFavoritesList', () => {
    const bitMaskFlagBool = getIsBitSet(16384, getGlobalSettingsAccountMailboxInfo());

    const mailLayoutFlag = shouldHideFavoritesList();
    if (bitMaskFlagBool !== mailLayoutFlag) {
        getStore().hideFavoritesList = bitMaskFlagBool;
    }
});

export default initializeShouldHideFavoritesList;
